export const convertToFahrenheit = (input) => {
  let celsius = input
  if(typeof input === 'string' && input.charAt(0) === "M") {
    celsius = input.slice(1) * -1
  }
  return  (celsius * (9 / 5)) + 32
}



// WEBPACK FOOTER //
// ./src/util/temperature.js